import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from 'components/UI/Modal/ModalPrimitive'
import { VariantForm, FormVariant } from './ProductModal/VariantForm'
import { notifyError } from 'services/toast'
import { useCreateVariant } from 'services/products_api'
import { usePreferences } from 'context/preferences/PreferencesContext'

interface StandaloneVariantModalProps {
  show: boolean
  onHide: () => void
}

export const StandaloneVariantModal: React.FC<StandaloneVariantModalProps> = ({
  show,
  onHide,
}) => {
  const createVariantMutation = useCreateVariant()
  const { preferences, isLoading } = usePreferences()
  const reportingUnit = preferences?.reporting_unit

  const handleSave = async (variantData: FormVariant): Promise<void> => {
    try {
      await createVariantMutation.mutateAsync(variantData)
      // Close modal on success
      onHide()
    } catch (err) {
      console.error('Failed to create variant:', err)
      notifyError('Failed to create variant. Please try again.')
      throw err
    }
  }

  // Show loading UI while preferences are loading
  if (isLoading) {
    return (
      <Dialog open={show} onOpenChange={(open) => !open && onHide()}>
        <DialogContent id="variant-modal-content" size="lg" className="px-3">
          <DialogHeader>
            <DialogTitle>Create New Variant</DialogTitle>
          </DialogHeader>
          <div className="mt-4 text-center py-8 text-gray-500">Loading...</div>
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Dialog open={show} onOpenChange={(open) => !open && onHide()}>
      <DialogContent id="variant-modal-content" size="lg" className="px-3">
        <DialogHeader>
          <DialogTitle>Create New Variant</DialogTitle>
        </DialogHeader>
        <div className="mt-4 overflow-auto">
          <VariantForm
            onSave={handleSave}
            onCancel={onHide}
            initialData={null}
            reportingUnit={reportingUnit}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
